export const isSuperAdmin = () => {
  const user = sessionStorage.getItem("user")
    ? JSON.parse(sessionStorage.getItem("user"))
    : null;
  const roleName = (user?.role_name || "").toLowerCase();
  return roleName === "super admin" || roleName === "admin";
};

export const hasAdminPermission = (action) => {
  if (isSuperAdmin()) {
    return true;
  }

  if (!action) return true;

  const permissions = sessionStorage.getItem("adminPermissions")
    ? JSON.parse(sessionStorage.getItem("adminPermissions"))
    : [];

  return permissions.some(
    (perm) => perm.action === action || perm.link === action
  );
};

export const getAllowedAdminPaths = () => {
  if (isSuperAdmin()) {
    return null;
  }

  const permissions = sessionStorage.getItem("adminPermissions")
    ? JSON.parse(sessionStorage.getItem("adminPermissions"))
    : [];

  const paths = permissions
    .map((perm) => perm.link || perm.action)
    .filter((link) => link && link.trim() !== "");

  return Array.from(new Set(paths));
};

export const canAccessAdminPath = (path) => {
  if (isSuperAdmin()) {
    return true;
  }

  if (!path || path === "") {
    return hasAdminPermission("clients");
  }

  const allowedPaths = getAllowedAdminPaths() || [];
  return (
    allowedPaths.includes(path) ||
    hasAdminPermission(path)
  );
};
